import ImgWithSignedUrl from "components/SignedUrl/ImgWithSignedUrl";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { truncateString } from "utils/UtilityFuncs";

function LeadDetailsColumn({ leadDetails, refreshFunc }) {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  /*   ALL STATES
   ********************************************* */
  const [formData, setFormData] = useState({ ...leadDetails });
  const [leadDetailsModal, setLeadDetailsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [filesList, setFilesList] = useState([]);

  /*   ALL FUNCTIONS
   ********************************************* */
  const updateLeadDetails = async (e) => {
    e.preventDefault();

    const newFormData = new FormData();

    for (let i = 0; i < filesList.length; i++) {
      newFormData.append("files", filesList[i]?.file);
    }

    let updatedData = {
      ...formData,
      paymentTermsId:
        formData.paymentTermsId === "null" ? null : formData.paymentTermsId,
      discountId: formData.discountId === "null" ? null : formData.discountId,
      id: leadDetails.id,
    };
    newFormData.append("updatedData", JSON.stringify(updatedData));

    let updatedFilesList = filesList.map((item) => {
      let folder;

      folder = `kms/lead/${leadDetails?.id}/brandNeckLabels`;
      return {
        folder,
        originalname: item?.fileName,
        title: item?.title,
      };
    });
    newFormData.append("filesList", JSON.stringify(updatedFilesList));
    setIsLoading(true);

    try {
      const { data } = await API.patch("/leads", newFormData, {
        headers: {
          "x-access-token": user?.accessToken,
          "Content-Type": "multipart/form-data",
        },
      });
      if (data.success) {
        await refreshFunc(leadDetails.id);
        setIsLoading(false);
        setLeadDetailsModal(false);
        return;
      }
      dispatch(
        setNotification({
          message: data,
          type: "error",
        })
      );
    } catch (err) {
      setIsLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const handleFileSelect = (e) => {
    let { id, name } = e.target;
    id = parseInt(id);
    let file = e.target.files[0];
    // Only Allow png, jpg, jpeg files
    if (
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "image/jpeg"
    ) {
      e.target.value = null;
      return dispatch(
        setNotification({
          message: "Only png, jpg, jpeg files are allowed",
          type: "error",
        })
      );
    }

    let fileName = file.name;

    // Check if file with same id is present
    let isPresent = filesList.find((item) => item.id === id);
    if (isPresent) {
      let updatedFilesList = filesList.map((item) => {
        if (item.id === id) {
          return { ...item, file, fileName };
        }
        return item;
      });
      setFilesList(updatedFilesList);
    } else {
      setFilesList((prev) => {
        return [
          ...prev,
          {
            id,
            title: name,
            file,
            fileName,
          },
        ];
      });
    }
  };

  const deleteNeckLabel = async (key) => {
    try {
      setIsLoading(true);
      const { data } = await API.post(
        "/leads/delete-neck-label",
        {
          id: leadDetails?.id,
          file: key,
        },
        { headers: authHeader() }
      );
      console.log(data);
      await refreshFunc();
      dispatch(
        setNotification({
          message: data,
          type: "error",
        })
      );
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    setFormData(leadDetails);
  }, [leadDetails]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center w-100 mb-1">
        <h4 className="border-bottom border-secondary">LEAD DETAILS</h4>
        <div className="ms-2">
          <button
            className="btn d-flex justify-content-center align-items-center btn-sm btn-success"
            style={{ width: 28, height: 28 }}
            onClick={() => {
              setLeadDetailsModal(true);
              setFormData(leadDetails);
            }}
          >
            <i className="mdi fs-5 mdi-pencil"></i>
          </button>
        </div>
      </div>

      <div className="d-flex align-items-start">
        <div className="d-flex flex-column me-2 " style={{ minWidth: 110 }}>
          <div className="d-flex  flex-column me-2">
            <div className="text-right">External Lead ID</div>
          </div>
          <div className="">Website</div>

          <div className="">Lead Reference</div>
          <div className="">Lead Type</div>
          <div className="">Custom Field 1</div>
          <div className="">Custom Field 2</div>
          <div className="">Custom Field 3</div>
        </div>

        <div className="">
          <div className="text-wrap text-truncate">
            :&nbsp;&nbsp;&nbsp;
            {leadDetails?.externalLeadId
              ? truncateString(leadDetails?.externalLeadId, 10)
              : "-"}
          </div>
          <div className="">
            :&nbsp;&nbsp;&nbsp;
            {leadDetails?.website
              ? truncateString(leadDetails?.website, 10)
              : "-"}
          </div>

          <div className="">
            <div className=" ">
              :&nbsp;&nbsp;&nbsp;
              {leadDetails?.leadReference
                ? truncateString(leadDetails?.leadReference, 10)
                : "-"}
            </div>
            <div className="d-flex align-items-center justify-content-between">
              :&nbsp;&nbsp;&nbsp;
              {leadDetails?.leadType
                ? truncateString(leadDetails?.leadType, 10)
                : "-"}
            </div>
            <div className="d-flex align-items-center justify-content-between">
              :&nbsp;&nbsp;&nbsp;
              {leadDetails?.customField1
                ? truncateString(leadDetails?.customField1, 10)
                : "-"}
            </div>
            <div className="d-flex align-items-center justify-content-between">
              :&nbsp;&nbsp;&nbsp;
              {leadDetails?.customField2
                ? truncateString(leadDetails?.customField2, 10)
                : "-"}
            </div>
            <div className="d-flex align-items-center justify-content-between">
              :&nbsp;&nbsp;&nbsp;
              {leadDetails?.customField3
                ? truncateString(leadDetails?.customField3, 10)
                : "-"}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="flex-grow-1 d-flex align-items-start">
        <div className="d-flex flex-column me-2 " style={{ minWidth: 110 }}>
          <div className="">Brand Neck Label</div>
        </div>

        <div className="">
          <div className=" ">
            :&nbsp;&nbsp;&nbsp;
            {leadDetails?.brandNeckLabel ? (
              <ImgWithSignedUrl
                path={leadDetails?.brandNeckLabel}
                width={30}
                height={30}
              />
            ) : (
              "-"
            )}
          </div>
        </div>
      </div>

      <Modal
        show={leadDetailsModal}
        onHide={() => setLeadDetailsModal(false)}
        size="lg"
      >
        <Modal.Body>
          <form onSubmit={updateLeadDetails}>
            <div className="row p-3 pt-1">
              <div className="">
                <h4 className="">Lead Details</h4>
              </div>
              <hr className="mb-3 mt-0" />
              <div className="col-12 mb-2">
                <div className="row mb-2">
                  <label className="col-3 my-auto">Lead Name</label>
                  <div className="col-9">
                    <input
                      type="text"
                      value={formData?.leadName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          leadName: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="Enter Lead Name"
                    />
                  </div>
                </div>
                <div className="row mb-2">
                  <label className="col-3 my-auto">
                    Brand Neck Label <br />
                    <small>( W x H : 200px x 200px )</small>
                  </label>
                  <div className="col-9 d-flex align-items-center gap-2">
                    <input
                      onChange={handleFileSelect}
                      id="brandNeckLabel"
                      name="brandNeckLabel"
                      className="form-control"
                      type="file"
                    />
                    {formData?.brandNeckLabel && (
                      <div style={{ position: "relative" }}>
                        <ImgWithSignedUrl
                          path={formData?.brandNeckLabel}
                          height={50}
                          width={50}
                        />
                        <button
                          onClick={() => {
                            deleteNeckLabel(formData?.brandNeckLabel);
                          }}
                          className="btn btn-danger btn-sm p-0 px-1"
                          style={{ position: "absolute", top: 0, left: 0 }}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <hr />
              </div>
              {/* <hr className='mb-3 mt-0' /> */}
              <div className="row">
                <div className="col-md-12">
                  <div className="row mb-2">
                    <label className="col-4 my-auto">External Lead ID</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.externalLeadId}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            externalLeadId: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter external lead ID"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <label className="col-4 my-auto">Website</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.website}
                        onChange={(e) =>
                          setFormData({ ...formData, website: e.target.value })
                        }
                        className="form-control"
                        placeholder="Enter Website"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <label className="col-4 my-auto">Lead Reference</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.leadReference}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            leadReference: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Lead Reference"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-4 my-auto">Lead Type</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.leadType}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            leadType: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Lead Type"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-4 my-auto">Custom Field 1</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.customField1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField1: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Custom Field 1"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-4 my-auto">Custom Field 2</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.customField2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField2: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Lead Type"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-4 my-auto">Custom Field 3</label>
                    <div className="col-8 ">
                      <input
                        type="text"
                        value={formData?.customField3}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField3: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Lead Type"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {isLoading && <Spinner />}
              {/*   Buttons
               ********************************************* */}
              <div className="mt-3 flex-grow-1 d-flex justify-content-end align-items-end">
                <div>
                  <button
                    onClick={() => {
                      setLeadDetailsModal(false);
                    }}
                    type="button"
                    className="btn btn-secondary me-2 px-1"
                  >
                    CLOSE
                  </button>
                  <button type="submit" className="btn btn-primary">
                    UPDATE
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default LeadDetailsColumn;
